import React, { FC } from 'react';
import CMPImage from 'components/global/image';
interface Props {
  wh?: number;
}
const WoodcuttingIcon: FC<Props> = ({ wh }) => {
  return (
    <CMPImage
      asset={{
        src: `${process.env.PUBLIC_URL}/images/professions/Woodcutting.png`,
        alt: 'Woodcutting',
      }}
      width={wh || 64}
      height={wh || 64}
    />
  );
};

export default WoodcuttingIcon;
